var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-toolbar-items",
    { staticClass: "hidden-xs-only" },
    [
      _c(
        "v-menu",
        {
          attrs: { "open-on-hover": "", bottom: "", "offset-y": "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: { text: "", to: "/people" },
                          on: { click: _vm.setUserAsSelected }
                        },
                        "v-btn",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("img", {
                        staticClass: "toolbar-title-img ma-3",
                        attrs: { src: _vm.user.photoURL, alt: "user photo" }
                      }),
                      _vm._v(" "),
                      _c(
                        "v-list-item-title",
                        { staticClass: "primary--text user-name" },
                        [_vm._v(_vm._s(_vm.user.displayName))]
                      ),
                      _vm._v(" "),
                      _c("v-icon", { staticClass: "primary--text" }, [
                        _vm._v("keyboard_arrow_down")
                      ])
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c(
            "v-list",
            _vm._l(_vm.vertItems, function(item, index) {
              return _c(
                "v-list-item",
                { key: index, on: { click: _vm.signout } },
                [_c("v-list-item-title", [_vm._v(_vm._s(item.title))])],
                1
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7385360d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7385360d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavItems.vue
// module id = He5q
// module chunks = 1